import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

@Injectable({ providedIn: 'root' })
export class DpLancamentoRubricasService {
  private readonly url = `${environment.apiUrl}/v1/dp/esocial/importar`;

  constructor(private readonly http: HttpClient) {}

  lancar(
    codiEmp: number,
    arquivos: File[],
    somenteRescisoes: boolean,
    aPartirDe?: string
  ): Observable<HttpResponse<Blob>> {
    const form = new FormData();
    for (const arquivo of arquivos) {
      form.append('xmls', arquivo, arquivo.name);
    }

    let params = new HttpParams().set('codi_emp', codiEmp);
    if (somenteRescisoes) {
      params = params.set('somente_rescisoes', 'true');
    }
    const data = aPartirDe?.trim();
    if (data) {
      params = params.set('a_partir_de', data);
    }

    return this.http.post(this.url, form, {
      params,
      responseType: 'blob',
      observe: 'response'
    });
  }
}
